import 'jquery.cookie';

import $ from 'jquery';
import ko from 'knockout';

$(function () {
    const specialVersionToggle = $('#id-special-version-toggle'),
        specialVersionControlBar = $('#id-special-version-control-bar');

    function SpecialVersionToggleViewModel() {
        const self = this;

        self.cookie_key = 'fkr_special_version';
        self.isSpecialVersion = $.cookie(self.cookie_key) === 'true';

        self.toggleSpecialVersion = function () {
            $.cookie(self.cookie_key, !self.isSpecialVersion, {path: '/'});
            window.location.reload();
        };

        self.initSpecialVersion = function () {
            $('body').css('visibility', 'visible');
            $('span', specialVersionToggle).html('Обычная версия');
        };

        if (self.isSpecialVersion) {
            self.initSpecialVersion();
        }
    }

    function SpecialVersionControlBarViewModel() {
        const self = this;

        self.defaults = {
            font_size: '14px',
            letter_spacing: 'normal',
        };

        self.cookie_key = 'fkr_special_version_data';
        self.data = $.cookie(self.cookie_key);
        self.elements = $('#id_wrapper *');

        self.letterSpacing = ko.observable();

        if (self.data) {
            self.parsed = JSON.parse(self.data);
        } else {
            self.parsed = self.defaults;
        }

        /**
         * Storing params in cookies in JSON string.
         */
        self.storeCookie = function () {
            $.cookie(self.cookie_key, JSON.stringify(self.parsed));
        };

        /**
         * Font size related.
         */
        self.changeFontSize = function (font_size) {
            if (font_size) {
                self.parsed.font_size = font_size;
                self.storeCookie();
            }

            self.elements.css('font-size', self.parsed.font_size, 'important');
        };

        if ($.cookie('fkr_special_version') === 'true') {
            self.letterSpacing.subscribe(function (value) {
                self.parsed.letter_spacing = value;
                self.elements.css('letter-spacing', value, 'important');
                self.storeCookie();
            });
            self.letterSpacing(self.parsed.letter_spacing);

            self.changeFontSize();
        }
    }

    ko.applyBindings(new SpecialVersionToggleViewModel(), specialVersionToggle[0]);
    ko.applyBindings(new SpecialVersionControlBarViewModel(), specialVersionControlBar[0]);
});


// WEBPACK FOOTER //
// ./js/common/special_version.js